/**
 * Why an inspection ran.
 *
 * One list, because there were four: the server's own union, the governance MCP
 * tool schema, the web's wire schema and the web's display type. Adding
 * `reassessment` to two of them and missing the other two broke the build, and
 * the failure mode of the pair that was missed is worse than a build error — a
 * closed literal union on the wire means a run of the new kind fails to decode
 * and takes the whole run list with it.
 *
 * @module inspectionTriggers
 */

export const INSPECTION_TRIGGERS = [
  "daily",
  "weekly",
  "upload",
  "manual",
  "finding",
  /** One document's findings re-read after its content changed. */
  "reassessment",
] as const;

export type InspectionTrigger = (typeof INSPECTION_TRIGGERS)[number];
